import { render } from "./LoadPill.vue?vue&type=template&id=259a3fdb"
import script from "./LoadPill.vue?vue&type=script&lang=js"
export * from "./LoadPill.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\ssradius\\frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__